import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchFilters } from '../../../staticSiteBackend/resources';
var defaultFilters = [{
  id: "label",
  searchableId: "label",
  displayName: "Type of content"
}, {
  id: "tags",
  searchableId: "tags",
  displayName: "Topic"
}];
export var createFiltersQuery = function createFiltersQuery(client) {
  var filtersObjs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFilters;
  return [["resources", "filters"], function (_ref) {
    var signal = _ref.signal;
    return fetchFilters({
      client: client,
      filtersObjs: filtersObjs,
      options: {
        signal: signal
      }
    });
  }];
};
export var useFiltersQuery = createQueryHook(createFiltersQuery, useStaticSiteBackend, {
  staleTime: Infinity
});